<template>
  <v-app :class="$vuetify.breakpoint.smAndDown ? 'pa-5' : ''">
    <v-snackbar
      app
      v-model="bar_show"
      :color="color"
      top
      right
      rounded
      elevation="24"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="bar_show = false"> Close </v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-col class="d-flex justify-center align-center" cols="12" md="6">
        <div>
          <div>
            <img class="logo" src="@/assets/Logo.svg" alt="Covesto logo" />
            <!-- <div class="blue-line mb-4"></div> -->
          </div>

          <div class="header mt-4">Daily Equity Trading Calls Subscription</div>
          <div
            :class="$vuetify.breakpoint.xsOnly ? 'mt-0' : 'mt-8'"
            class="sub-header font-weight-bold"
          >
            Never miss a profitable trading opportunity again
          </div>
          <div class="mt-6">
            <div class="list">
              <div class="d-flex align-center">
                <picture class="mr-3">
                  <v-img class="list-img" :src="phoneIcon"> </v-img>
                </picture>
                <div>Receive 3-4 daily calls</div>
              </div>
              <div class="d-flex align-center">
                <picture class="mr-3">
                  <v-img class="list-img" :src="headPhoneIcon"> </v-img>
                </picture>
                <div>
                  Live market assistance by SEBI RA Reg No. INH000015835
                </div>
              </div>
              <div class="d-flex align-center">
                <picture class="mr-3">
                  <v-img class="list-img" :src="whatsAppIcon"> </v-img>
                </picture>
                <div>Entry and exit alerts on WhatsApp</div>
              </div>
              <div class="d-flex align-center">
                <picture class="mr-3">
                  <v-img class="list-img" :src="arrowAccuracyIcon"> </v-img>
                </picture>
                <div>70% Monthly Accuracy</div>
              </div>
              <div class="d-flex align-center">
                <picture class="mr-3">
                  <v-img class="list-img" :src="customToolsIcon"> </v-img>
                </picture>
                <div>
                  Free tools and insights for efficient market navigation
                </div>
              </div>
            </div>
          </div>
          <div
            :class="$vuetify.breakpoint.xsOnly ? 'text-center d-none' : ''"
            class="mt-8 pt-3"
          >
            <div class="covesting-tech mb-5 font-weight-bold">
              Covesting Technologies Private Limited
            </div>
            <div class="d-flex align-center mb-3">
              <picture class="mr-3">
                <v-img class="list-img" :src="mailIcon"> </v-img>
              </picture>
              <div>
                <a
                  class="telephone text-decoration-underline"
                  href="mailto: team@covesting.in"
                >
                  team@covesting.in</a
                >
              </div>
            </div>

            <div class="d-flex align-center mt-3">
              <picture class="mr-3">
                <v-img class="list-img" :src="teleohoneIcon"> </v-img>
              </picture>
              <div>
                <a
                  class="telephone text-decoration-underline"
                  href="tel:+919572380912"
                  >+91 9572380912</a
                >
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col class="login-bg d-flex" cols="12" md="6">
        <v-col class="" style="margin: auto" cols="12" md="8">
          <v-card elevation="3" class="pa-12">
            <!-- <v-img height="65px" width="100px" :src="covesto_logo"> </v-img> -->
            <v-form ref="paymentForm">
              <v-row class="auth-bg d-flex justify-center">
                <!-- <v-col cols="12" class="text-center login-header pt-0">
                  <v-img height="65px" width="100px" :src="covesto_logo">
                  </v-img>
                </v-col> -->
                <v-col cols="12" class="text-center login-header mb-4">
                  <span v-if="!show_otp">Payment Details </span>
                  <div v-if="show_otp">Verify Contact Number</div>
                  <div
                    class="edit-txt d-flex justify-center align-center mb-5"
                    v-if="show_otp"
                  >
                    <div class="mr-1 my-2">
                      Enter 4 digit OTP sent to <strong>{{ phone }} </strong>
                    </div>
                    <div>
                      <img
                        class=""
                        style="cursor: pointer"
                        @click="show_otp = false"
                        :src="editIcon"
                        alt="edit"
                      />
                    </div>
                  </div>
                </v-col>
                <v-col v-if="!show_otp" cols="12">
                  <label class="">Full Name</label>
                  <sup style="color: #eb5757">*</sup>
                  <v-text-field
                    outlined
                    :rules="[rules.required, rules.text]"
                    v-model="name"
                    dense
                    placeholder="Enter Name"
                  ></v-text-field>
                </v-col>
                <v-col v-if="!show_otp" cols="12" class="mb-5">
                  <label class="">Mobile</label>
                  <sup style="color: #eb5757">*</sup>
                  <!-- @keyup.enter="login" -->
                  <v-text-field
                    outlined
                    v-model="phone"
                    @keypress="isNumber($event)"
                    @keyup.enter="login()"
                    :disabled="show_otp"
                    background-color="#fff"
                    dense
                    maxlength="10"
                    ref="mobile"
                    prefix="+91 "
                    :rules="[rules.required, rules.phone]"
                    placeholder="Enter Mobile Number"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center flex-column mb-5"
                  v-if="show_otp"
                >
                  <div class="text-center label">
                    Enter OTP
                    <sup style="color: #eb5757">*</sup>
                  </div>

                  <v-otp-input
                    style="width: 250px"
                    v-model="otp"
                    type="password"
                    @keyup.enter="sendOtp()"
                    length="4"
                  ></v-otp-input>

                  <!-- <v-text-field
                    v-model="otp"
                    dense
                    placeholder=" Enter OTP"
                  ></v-text-field> -->
                </v-col>
                <v-col v-if="show_otp" cols="12">
                  <div
                    v-if="!show_resend"
                    @click="resend()"
                    class="resend mb-2"
                  >
                    Resend OTP
                  </div>
                  <div v-else class="resedOtp-txt d-flex justify-center">
                    <div class="mr-2">Resend OTP</div>
                    <div class="">{{ show_time }}</div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    v-if="!show_otp"
                    @click="login()"
                    block
                    :loading="phoneLoader"
                    class="proceed"
                    height="48px"
                    color="primary"
                  >
                    <span class="btn-txt"> Send OTP </span>
                  </v-btn>
                  <v-btn
                    v-else
                    @click="sendOtp()"
                    block
                    class="proceed"
                    color="primary"
                    height="48px"
                    :loading="otpLoader"
                  >
                    <span class="btn-txt"> Verify </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-col>
      <div
        :class="!$vuetify.breakpoint.xsOnly ? 'text-center d-none' : ''"
        class="pa-3"
      >
        <div class="covesting-tech mb-5 font-weight-bold">
          Covesting Technologies Private Limited
        </div>
        <div class="d-flex align-center mb-3">
          <picture class="mr-3">
            <v-img class="list-img" :src="mailIcon"> </v-img>
          </picture>
          <div>
            <a
              class="telephone text-decoration-underline"
              href="mailto: team@covesting.in"
            >
              team@covesting.in</a
            >
          </div>
        </div>

        <div class="d-flex align-center mt-3">
          <picture class="mr-3">
            <v-img class="list-img" :src="teleohoneIcon"> </v-img>
          </picture>
          <div>
            <a
              class="telephone text-decoration-underline"
              href="tel:+919572380912"
              >+91 9572380912</a
            >
          </div>
        </div>
      </div>
    </v-row>
    <PaymentModal></PaymentModal>
  </v-app>
</template>

<script>
import fieldRules from "@/common/fieldRules";
import Axios from "@/api/BaseAxios";
import { mapGetters, mapActions } from "vuex";
import commonFunctions from "@/common/commonFunctions";
import PaymentModal from "@/components/Group/PaymentDetail/PaymentDetail.vue";

export default {
  name: "paymentFlow",
  components: { PaymentModal },
  data() {
    return {
      text: "",
      color: "",
      timeout: 3000,
      bar_show: false,
      // Snackbar
      commonFun: commonFunctions,
      // resednd
      min: 2,
      sec: 60,
      time: 0,
      resetTime: null,
      show_resend: false,
      // show_time: "",
      show_otp: false,
      rules: fieldRules,
      name: "",
      phone: "",
      otp: "",
      phoneLoader: false,
      otpLoader: false,
      covesto_logo: require("@/assets/covesto_logo.png"),
      phoneIcon: require("@/assets/images/ra.covesto.in/phone-call.svg"),
      headPhoneIcon: require("@/assets/images/ra.covesto.in/headset.svg"),
      whatsAppIcon: require("@/assets/images/ra.covesto.in/whatsapp.svg"),
      arrowAccuracyIcon: require("@/assets/images/ra.covesto.in/bullseye-arrow.svg"),
      customToolsIcon: require("@/assets/images/ra.covesto.in/customize.svg"),
      mailIcon: require("@/assets/images/ra.covesto.in/mail.svg"),
      teleohoneIcon: require("@/assets/images/ra.covesto.in/telephone.svg"),
      authCoverImage: require("@/assets/images/ra.covesto.in/auth-cover-img.svg"),
      editIcon: require("@/assets/images/ra.covesto.in/editIcon.svg"),
    };
  },
  //   created() {
  //     this.$store.subscribe((mutation, state) => {
  //       if (mutation.type === "snackBar/SHOW_MESSAGE") {
  //         this.text = state.snackBar.text;
  //         this.color = state.snackBar.color;
  //         this.timeout = state.snackBar.timeout;
  //         this.show = true;
  //       }
  //     });
  //   },
  computed: {
    ...mapGetters({
      paymentShow: "payment/getShow",
    }),
    detail() {
      let detail = {};
      // production
      detail["group_id"] = 2145;
      // detail["plan"] = 35;
      // staging and devlopment
      // detail["group_id"] = 426;
      // detail["plan"] = 263;
      detail["user_id"] = this.commonFun.getUserId();
      return detail;
    },
    show: {
      get() {
        return this.paymentShow;
      },
      set(value) {
        return this.togglePaymentDetail({ show: value });
      },
    },
    show_time() {
      return `${this.min}m: ${this.sec}s`;
    },
  },
  watch: {
    time(value) {
      if (value == 2) {
        this.sec = 60;
        this.show_resend = true;
        this.min == 2;
        clearInterval(this.resetTime);
        this.show_resend = false;
      }
    },
  },
  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
      togglePaymentDetail: "payment/togglePaymentDetail",
    }),
    btnHandler() {
      // console.log("pay and join");
      this.togglePaymentDetail({ show: true, detail: this.detail });
      //   const url = `${location.protocol}//${location.host}/groups/75`;
      //   window.open(url, "_self");
      //   console.log("btn handler press");
      //   if (this.isPaymentHappening) {
      //     this.togglePaymentDetail({ show: true, detail: this.detail });
      //   } else {
      //     this.snackBar({
      //       text: "Payment Process is not active for this group yet",
      //       color: "warning",
      //       timeout: 2500,
      //     });
      //   }
    },
    resend() {
      this.show_resend = true;
      this.resetTime = setInterval(() => {
        if (this.sec == 0) {
          this.time++;
          this.sec = 60;
          this.min--;
        }
        this.sec--;
      }, 1000);
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    login() {
      if (this.$refs.paymentForm.validate()) {
        this.phoneLoader = true;
        console.log(this.phone.length);
        if (this.phone.length > 10 || this.phone.length < 10) {
          this.phoneLoader = false;
          return false;
        }
        const successHandler = (res) => {
          this.show_otp = true;
          // console.log(res.data.message, res.data.verified, "success message");
          this.phoneLoader = false;
          // this.$store.state.Auth.checkStatus = "OTP";
          localStorage.setItem("user_id", res.data.user_id);
          localStorage.setItem("profile_id", res.data.profile_id);
          // localStorage.setItem("access", res.data.token.access);
          // localStorage.setItem("refresh", res.data.token.refresh);
          //   this.showSnack({
          //     text: `${res.data.message}`,
          //     color: "success",
          //     timeout: 4500,
          //   });
          this.bar_show = true;
          this.text = res.data.message;
          this.color = "green";
          // this.$router.push(
          //   ROUTER_URL.auth.link + ROUTER_URL.auth.children.verifyOtp.link
          // );
          this.$logEvent("login_successful");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_login_successful");
          }
        };
        const errorHandler = (err) => {
          console.log(err, "this was error");
          this.bar_show = true;
          this.text = err.data.message;
          this.color = "red";
          this.phoneLoader = false;
        };
        const data = {
          phone: this.phone,
        };
        Axios.request_POST(
          "/api/login/",
          data,
          {},
          successHandler,
          errorHandler,
          false,
          false
        );
      }
    },
    saveProfile() {
      this.profileLoader = true;

      const user_id = localStorage.getItem("user_id");
      const data = {
        name: this.name,
        user_id: user_id,
      };
      const successHandler = (res) => {
        this.$store.state.Auth.flagVerified = res.data.verified;
        console.log(res.data, "profile");
        localStorage.setItem("verified", res.data.profile_detail.user_id);
        localStorage.setItem("profile_id", res.data.profile_detail.id);
        // const user_id = localStorage.getItem("user_id");

        this.$store.state.Auth.checkStatus = "HOME";
        let date = new Date();
        sessionStorage.setItem("session", date);
        this.$store.state.isPrivate = true;
        this.$store.state.Auth.is_logged_in = true;
        // this.$router.push({ name: "HomePage", params: { id: user_id } });
        // this.$router.push({ name: "TrendingPage" });
        // this.$router.push( .getRoute());
        this.$logEvent("profile_setup_successful");
        // this.togglePaymentDetail({ show: true });
        this.btnHandler();
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_profile_setup_successful");
        }
        this.profileLoader = false;
      };
      const errorHandler = (err) => {
        console.log(err);
        this.showSnack({
          text: `${err.data.message}`,
          color: "error",
          timeout: 4500,
        });
        this.date_of_birth = null;
        this.profileLoader = false;
      };
      Axios.request_POST(
        "/api/create-profile/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        true
      );
    },
    sendOtp() {
      if (this.$refs.paymentForm.validate() && this.otp.length === 4) {
        this.otpLoader = true;
        const user_id = localStorage.getItem("user_id");
        const successHandler = (res) => {
          this.bar_show = true;
          this.text = res.data.message;
          this.color = "green";

          this.otpLoader = false;
          this.$logEvent("verify_otp_successful");

          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_verify_otp_successful");
          }

          localStorage.setItem("token", res.data.token);
          // const user_id = localStorage.getItem("user_id");
          localStorage.setItem("profile_id", res.data.profile_id);
          localStorage.setItem("access", res.data.token.access);
          localStorage.setItem("refresh", res.data.token.refresh);
          localStorage.setItem("verified", res.data.verified);
          localStorage.setItem("user_type", res.data.user_type);
          if (res.data.verified) {
            this.$store.state.Auth.flagVerified = res.data.verified;

            this.$store.state.isPrivate = true;
            this.$store.state.Auth.checkStatus = "HOME";
            let date = new Date();
            sessionStorage.setItem("session", date);
            //   this.togglePaymentDetail({ show: true });
            this.btnHandler();

            // this.$router.push({ name: "TrendingPage" });
            //   this.$router.push(ROUTING_HANDLER.getRoute());
          } else {
            this.saveProfile();
            //   this.$router.push({
            //     name: ROUTER_URL.auth.children.completeProfile.name,
            //   });
          }
        };
        const errorHandler = () => {
          // console.log(err, "this is error");

          this.bar_show = true;
          // snackbar
          this.text = "Invalid OTP";
          this.color = "red";
          this.otpLoader = false;
        };
        const finallyHandler = () => {
          this.otpLoader = false;
        };
        const data = {
          otp: this.otp,
        };
        Axios.request_POST(
          `api/verify_otp/${user_id}/`,
          data,
          {},
          successHandler,
          errorHandler,
          false,
          false,
          finallyHandler
        );
      } else {
        this.bar_show = true;
        this.text = "All fields are required";
        this.color = "red";
      }
    },
    // sendOtp() {},
  },
};
</script>

<style lang="scss" scoped>
.list-img {
  width: 25px;
  height: 25px;
}
.btn-txt {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.6px;
  text-align: center;
}
.login-header {
  font-family: Avenir;
  font-size: 29px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
  color: #333333;
}
.logo {
  width: 196px;
  height: 55px;
}
.blue-line {
  width: 110px;
  height: 10px;
  background: #2d8cff;
}
.edit-txt {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
}
.resedOtp-txt {
  font-family: Avenir;
  font-size: 21px;
  font-weight: 500;
  line-height: 28px;
}
.resend {
  color: #2d8cff;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.proceed {
  color: white;
  border-radius: 4px;
  text-transform: capitalize;
}
ul {
  list-style: none;
}
.list > div {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  color: #333333e5;
  margin-bottom: 16px;
}
.header {
  font-family: Avenir;
  // font-family: Avenir LT Std;
  font-size: 38px;
  color: #333333ee;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: -2px;
  text-align: left;
}
.sub-header {
  font-family: Avenir;
  font-size: 24px;
  font-weight: 500;
  line-height: 35px;
  text-align: left;
  color: #333333;
}
.auth-bg {
  background-color: #fff;
}
.covesting-tech {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 36px;
  text-align: left;
  color: #333333;
}
.telephone {
  font-family: Avenir;
  color: #333333;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
}
.label {
  font-family: Avenir;
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  color: #333333e5;
}
.login-bg {
  background-image: url("~@/assets/images/ra.covesto.in/auth-cover-img.svg");
  background-repeat: no-repeat;
  background-position: right center; /* Position the image to the right side */
}
@media only screen and (max-width: 768px) {
  ul > li {
    font-size: 12px;
  }
  .header {
    font-size: 30px;
  }
  .sub-header {
    font-size: 14px;
  }
}
</style>
